import CONST from "./Constant";

const INITIAL_STATE = {
    list:[],
    selected:{},
    error: [],
    code: "",
    config:{
        from:0,
        to:0,
        lastPage:1,
        total:0,
        pagination:{
            page:0,
            pageSize:10,
        },
        filters:{
            keyword:'',
            sort_by:'created_at',
            sort_dir:'desc',
        }
    },
    preview:{
        list:[],
        selected:{},
        config:{
            from:0,
            to:0,
            lastPage:1,
            total:0,
            pagination:{
                page:0,
                pageSize:10,
            },
            filters:{
                keyword:'',
            }
        },
    }
};

const Reducer = (state = INITIAL_STATE, action) => {

    switch (action.type){
        case CONST.SET_CONFIG:
            return {
                ...state,
                config: {
                    ...state.config,
                    ...action.payload
                },
            };
        case CONST.SET_CONFIG_PREVIEW:
            return {
                ...state,
                preview: {
                    ...state.preview,
                    config: {
                        ...state.preview.config,
                        ...action.payload
                    },
                },
            };
        case CONST.SET_SELECTED_ITEM:
            return {
                ...state,
                selected: state.list.find(item => item.id === action.payload) || {},
            }
        case CONST.FETCH_ITEM_SUCCESS:
            return {
                ...state,
                selected: action.payload.data,
                error: [],
                message: ["Report loaded successfully"],
                code:action.payload.status,
            }
        case CONST.FETCH_ITEMS_SUCCESS:
            return action.payload.config.params.paginate === undefined ? {
                ...state,
                list: action.payload.data.data,
                config:  {
                    ...state.config,
                    from:action.payload.data.from,
                    to:action.payload.data.to,
                    lastPage:action.payload.data.last_page,
                    total:action.payload.data.total,
                    pagination:{
                        ...state.config.pagination,
                        page:action.payload.data.current_page - 1,
                        pageSize:action.payload.data.per_page,
                    },
                },
                error: [],
                code:action.payload.status,
                message: ["Report loaded successfully"],
            } : {
                ...state,
                list: action.payload.data,
                error: [],
                code:action.payload.status,
                message: ["Report loaded successfully"],
            }
        case CONST.ADD_ITEM_SUCCESS:
            return {
                ...state,
                list:[...state.list,action.payload.data],
                selected: {},
                error: [],
                message: ["Report added successfully"],
                code:action.payload.status,
            }
        case CONST.UPDATE_ITEM_SUCCESS:
            const indexU = state.list.findIndex(item => item.id === action.payload.data.id);
            return {
                ...state,
                list: [...state.list.slice(0, indexU), action.payload.data, ...state.list.slice(indexU + 1)],
                selected: action.payload.data,
                error: [],
                message: ["Report updated successfully"],
                code:action.payload.status,
            }
        case CONST.DELETE_ITEM_SUCCESS:
            return {
                ...state,
                list:state.list.filter(item => item.id !== action.payload.data),
                selected: {},
                error: [],
                message: ["Report deleted successfully"],
                code:action.payload.status,
            }
        case CONST.FETCH_ITEM_PREVIEW_SUCCESS:
            return {
                ...state,
                preview: {
                    ...state.preview,
                    list: action.payload.data.data,
                },
                message: ["Report preview loaded successfully"],
            }
        case CONST.FETCH_ITEM_PREVIEW_FAILED:
            return {
                ...state,
                preview: {
                    ...state.preview,
                    list: [],
                },
                error: action.payload.data.errors,
                message: action.payload.data.message,
                code:action.payload.status,
            }
        case CONST.FETCH_ITEM_FAILED:
        case CONST.FETCH_ITEMS_FAILED:
        case CONST.ADD_ITEM_FAILED:
        case CONST.UPDATE_ITEM_FAILED:
        case CONST.DELETE_ITEM_FAILED:
            return {
                ...state,
                error: action.payload.data.errors,
                message: action.payload.data.message,
                code:action.payload.status,
            }
        default:
            return state;
    }
}

export default Reducer ;